<template lang="pug">
  div.home
    IngredientsForm(:startvalue="startvalue")
</template>
<script>
// @ is an alias to /src
import IngredientsForm from '@/components/IngredientsForm.vue'

export default {
  name: 'home',
  components: {
    IngredientsForm
  },
  data: function () {
    return {
      startvalue: null
    }
  },
  created: function () {
    const url = new URL(window.location)
    const ingredientParamater = url.searchParams.get('ingredienten')
    this.startvalue = ingredientParamater ? ingredientParamater.toLowerCase().replace('lekker bij', '') : ''
  }
}
</script>

<style lang="sass">
  main
    padding-top: 102px
  @media only screen and (min-width: 47.125em)
    main
      padding-top: 0
      margin-top: 4px
  #app
    height: 100%
    position: relative
</style>
